export const zh_CN = {
    translations: {
        values: {
            one: "一",
            two: "二",
            three: "三",
            four: "四",
            five: "五",
            six: "六",
            seven: "七",
            eight: "八",
            nine: "九",
            redFive: "赤五",
            east: "东",
            south: "南",
            west: "西",
            north: "北",
            white: "白",
            green: "发",
            red: "中",
            hidden: "hidden tile",
        },
        suits: {
            characters: "万",
            circles: "饼",
            bamboo: "索"
        },
        shuupai: "{{value}}{{suit}}",
        winds: {
            east: "东",
            south: "南",
            west: "西",
            north: "北"
        },
        roundName: "{{wind}}{{number}}局{{repeats}}本场",
        trainer: {
            disclaimer: "免责声明：这个工具将训练你在当前巡目中使手牌效率最大化的能力。它不会帮你在未来巡目最大化程度地提高效率，也无法了解何时应该忽略效率追求打点。训练工具所建议的方式并不是打麻将的最佳方法，但你会有想要这么打的地方。高手并非总是这么打，但是高手都可以这样玩。确保通过进一步阅读补充本训练内容，以了解何时这么打可能不是最佳玩法。此外，查看设置以进行更有针对性的培训。",
            instructions: "请点击你要打的牌。",
            start: "开始了一副新的手牌：{{hand}}",
            complete: "恭喜你听牌了！你的效率是{{achieved}}/{{total}}或{{percent}}%.",
            newHandButtonLabel: "新的手牌",
            loadButtonLabel: "加载手牌",
            roundWind: "场风：",
            seatWind: "自风：",
            doraIndicator: "宝牌指示牌：",
            copyHand: "复制手牌",
            copied: "复制成功！",
            error: {
                load: "错误：无法解析手牌",
                wallEmpty: "错误：手牌牌数不足",
                wallEmptyShuffle: "牌山存量不足，重新随机中。"
            },
            playerNames: {
                you: "自家",
                right: "下家",
                across: "对家",
                left: "上家"
            }
        },
        history: {
            label: "手牌历史",
            tenhouLinkText: "【天凤牌理】",
            concise: {
                discard: "舍牌{{tile}}",
                acceptance: "（{{count}}枚进张）。",
                acceptance_plural: "（{{count}}枚进张）。",
                tilesExpanded: "",
                loweredShanten: "（向听到退）。",
                optimal: "最佳舍牌：",
                optimalSpoiler: "{{tile}}",
                best: "这是最佳的舍牌！",
                exceptionalNoten: "你所听的牌都在手牌里，所以是空听。",
                furiten: "振听。",
                furitenWarning: "请注意可能会振听。",
                exhausted: "牌山已经没有牌了，下次好运！",
                draw: "你自摸：{{tile}}。"
            },
            verbose: {
                discard: "你选择打{{tile}}，",
                acceptance: "结果是有{{count}}张牌可以改善手牌向听数：",
                acceptance_plural: "结果是有{{count}}张牌可以改善手牌向听数：",
                tilesExpanded: " {{tiles}}。",
                loweredShanten: "向听数增加 - 你离听牌更远了。",
                optimal: "最佳舍牌是",
                optimalSpoiler: "{{tile}}。",
                best: "这是最佳的舍牌！",
                exceptionalNoten: "你听牌了，但是你所听的牌都在手牌里。大部分规则下都不算听牌，所以你需要改变你的手牌。",
                furiten: "你现在处于振听状态。你不能荣和，因为你有一张要和的牌在你舍牌里。",
                furitenWarning: "请注意可能会振听。能改善手牌的一些牌在你的舍牌里。",
                exhausted: "牌山已经没有牌了，下次好运！",
                draw: "你自摸{{tile}}。"
            }
        },
        discards: {
            label: "牌河",
            discardCount: "你已经打了{{count}}张牌。",
            discardCount_plural: "你已经打了{{count}}张牌。",
            tilesLeft: "牌山还剩{{count}}张。",
            tilesLeft_plural: "牌山还剩{{count}}张。"
        },
        settings: {
            buttonLabel: "设置",
            tilesAllowed: "允许的牌种类：",
            characters: "万子",
            circles: "饼子",
            bamboo: "索子",
            honors: "字牌",
            sanma: "三麻",
            redFives: "赤五枚数：",
            verbose: "不使用牌缩写（“一索” vs “1s”）",
            concise: "紧凑的手牌历史",
            spoilers: "显示最佳舍牌",
            shuffle: "开始新的手牌之后将舍牌随机放回牌山",
            simulate: "模拟其他玩家的舍牌",
            exceptions: "考虑特殊牌型（国士无双和七对子）",
            minShanten: "起始手牌最小向听数：",
            minShantenLimit: "(不超过允许的西服数量)",
            sort: "自动理牌",
            blind: "隐藏手牌",
            useTimer: "启用计时器",
            time: "每个决定的时间:",
            extraTime: "每只手都需要额外的时间:",
            seconds: "秒"
        },
        stats: {
            buttonLabel: "统计",
            info: "这些数据在你每次达成听牌之后更新。",
            ready: "听牌次数：{{count}}次",
            ready_plural: "听牌次数：{{count}}次",
            discards: "舍牌枚数：{{count}}枚",
            discards_plural: "舍牌枚数：{{count}}枚",
            average: "平均听牌巡目：{{average}}巡",
            optimal: "最佳舍牌次数：{{count}}次",
            optimal_plural: "最佳舍牌次数：{{count}}次",
            optimalRate: "最佳舍牌比例：{{percent}}% ({{achieved}}/{{total}})",
            efficiency: "达成的进张枚数：{{count}}枚",
            efficiency_plural: "达成的进张枚数：{{count}}枚",
            possible: "可能的进张枚数：{{count}}枚",
            possible_plural: "可能的进张枚数：{{count}}枚",
            overall: "综合牌效率： {{percent}}% ({{achieved}}/{{total}})",
            reset: "重置统计",
            confirmation: "你确定想要重置你的所有统计数据为0吗？你无法撤回这项操作。",
            yes: "是，我要重置！",
            no: "否，不要重置！"
        },
        credits: {
            label: "Credits",
            tilesPreLink: "Tile images combined from ",
            tilesLinkText: "riichi-mahjong-tiles by FluffyStuff on Github",
            tilesPostLink: ", licensed under the ",
            ccLinkText: "Creative Commons Attribution 4.0 International License.",
            shantenPreLink: "Shanten calculation algorithm adapted from ",
            shantenLinkText: "this C program collection.",
            shantenPostLink: "",
        },
        menu: {
            trainer: "牌效训练",
            analyzer: "牌谱分析",
            allLast: "终局训练",
            explorer: "牌理探索",
            utils: "其他工具",
            language: "语言",
            shanten: "向听训练",
            defense: "弃和训练"
        },
        allLast: {
            placements: {
                first: "第1名",
                second: "第2名",
                third: "第3名",
                fourth: "第4名"
            },
            title: "终局训练",
            maxFu: "最大符",
            showDifferences: "显示点数差",
            loadInstructions: "请输入东、南、西、北四位的点数（用逗号分隔）以载入对局情境。",
            loadLabel: "载入情境",
            newLabel: "生成随机情境",
            info: "当前是最后一局，也是整场比赛的最后一轮。你目前处于第4名，当前分数如下：",
            escapeHeader: "摆脱第4名",
            riichiHeader: "宣布立直",
            higherHeader: "更高名次",
            question: "你至少需要{{action}}多少点，才能升至{{placement}}？",
            riichiQuestion: "若{{player}}宣布立直，你至少需要{{action}}多少点，才能升至{{placement}}？",
            ron: "荣和{{target}}",
            tsumo: "自摸",
            han: "番",
            fu: "符",
            submit: "提交",
            wrong: "错误！这个点数无法让你升至{{placement}}！高亮查看答案：",
            tooMuch: "这个点数虽然能让你升至{{placement}}，但不是最低所需点数。高亮查看答案：",
            correct: "正确！这是升至{{placement}}所需的最低点数！",
            score: "{{han}}番{{fu}}符",
            results: "结果：",
            you: "你",
            error: {
                few: "错误：提供的分数数量不足。",
                NaN: "错误：无法识别{{seat}}的分数。"
            }
        },
        analyzer: {
            instructions1: "注意：只接受天凤和雀魂的牌谱回放链接",
            instructions2: "将你的回放链接粘贴到文本框中。",
            instructions3: "然后，右键点击生成的链接，选择“另存为”或“链接另存为”。",
            instructions4: "最后，点击“浏览...”并上传你保存的文件。",
            instructions5: "或者，如果你电脑上已有 mjlog 文件，也可以将它的后缀改成 .zip。",
            instructions6: "然后上传压缩包中包含的文件即可。",
            instructions7: "如果你有其他程序可以直接获取回放 XML 文件，也可以直接上传这些 XML 文件。",
            instructions8: "此处也适用牌效训练中的免责声明。",
            instructions9: "关于安全评级，数值越高表示越安全，1 为最低，15 为最高。",
            URLplaceholder: "牌谱回放链接",
            invalidURL: "无效或错误链接",
            downloadInstructions: "点击右键另存为到硬盘！",
            roundSelect: "选择牌局",
            playerSelect: "切换玩家",
            previousTurn: "上一轮",
            nextTurn: "下一轮",
            nextIssue: "下一个问题",
            turn: "{{round}}, 第{{turn}}轮",
            discards: "你的舍牌: {{symbols}} ({{tiles}})",
            calls: "你的鸣牌: {{calls}}",
            callsSeparator: ", ",
            tenhouLinkText: "【天凤牌理】",
            replayError: "回放有问题，请发给我研究",
            noName: "Unknown",
            startingHand: "你的起手牌是{{hand}}。你距离和牌还差{{count}}张牌。当前的宝牌指示牌是{{dora}}。",
            startingHand_plural: "你的起手牌是{{hand}}。你距离和牌还差{{count}}张牌。当前的宝牌指示牌是{{dora}}。",
            unknownAction: "嘿，这个回放有我没有处理的情况。请把这个回放发给我，我会添加处理。{{debugInfo}}",
            call: "你鸣牌{{tile}}来完成{{meld}}。（{{hand}}）",
            callSameShanten: "这个鸣牌没有让你更接近听牌。",
            ryuukyoku: "本局以平局结束。",
            playerRiichi: "你宣布了立直。分析结束。",
            otherRiichi: "玩家{{number}}宣布了立直。",
            fold: "你距离听牌还差{{shanten}}张牌，所以你应该弃牌。",
            probablyFold: "你离听牌只差一张牌，你应该考虑弃牌。",
            win: "玩家{{number}}赢得了这一局。",
            kandora: "新的宝牌指示牌是{{tile}}。",
            draw: "自摸{{tile}}。（{{hand}}）",
            chosenSafety: "{{tile}}的安全等级是{{rating}}。（{{- explanation}}）",
            correctSafety: "那是最安全的牌。",
            bestSafety: "最安全的牌是{{tile}}，安全等级{{rating}}。（{{- explanation}}）",
            safetyExplanations: {
                zero: "You shouldn't see this message. Tell me if you do.",
                one: "无筋 4/5/6",
                two: "无筋 3/7",
                three: "无筋 2/8",
                four: "one-chance",
                five: "无筋 1/9",
                six: "生张 字牌",
                seven: "筋牌 3/7",
                eight: "筋牌 2/8",
                nine: "筋牌 4/5/6",
                ten: "现一 字牌",
                eleven: "生张 筋牌 老头牌",
                twelve: "现一 筋牌 老头牌",
                thirteen: "现二 筋牌 老头牌 / 现二 字牌",
                fourteen: "绝张 筋牌 老头牌 / 绝张 字牌",
                fifteen: "现物，100% 安全"
            }
        },
        explorer: {
            warning: "警告：加载手牌可能会导致页面停顿5到10秒，如果你的电脑较旧，停顿时间可能更长，具体取决于手牌的复杂性。加载手牌后，将展示每个弃牌的所有进张和优化可能性，包括那些会导致向听的可能性。默认情况下，不会显示那些明显比其他选项差的选项，但你可以按下面的按钮来改变这一设置。如果你只需要进张信息，使用 tenhou.net/2/ 网址即可满足需求。",
            shanten: "向听数：距离听牌还差几张牌",
            ukeire: "进张数：能减少向听数的牌的张数",
            notableDiscards: "仅显示关键舍牌",
            allDiscards: "显示所有可能的舍牌",
            discardInfo: {
                discard: "舍牌：{{tile}}",
                shanten: "向听数：{{count}}",
                ukeire: "进张数：{{count}} ({{tiles}})",
                expand: "显示下一向听的进张数",
                draw: "自摸 {{draw}}，舍牌 {{discard}}，{{count}} 进张",
                average: "平均值：{{average}}",
                upgrades: "提升进张的牌：{{count}} ({{tiles}})",
                expandUpgrades: "显示优化结果"
            }
        },
        defense: {
            instructions: "请打最安全的牌。",
            finalHands: "最终手牌：",
            hand: "{{player}}：{{hand}}",
            safetyRatings: "安全等级",
            averagedSafetyRating: "针对多家立直，安全等级将一并取平均值，并选择最高的为最佳。",
            safetyRating: "{{rating}}: {{- explanation}}",
            riichiCount: "立直数：",
            minTurns: "立直前最小巡数：",
            tilesInHand: "手牌枚数："
        },
        shanten: {
            instructions: "想提升你计算向听数的速度吗？这个工具可以帮助你练习。",
            newHandButtonLabel: "新的手牌",
            guessPlaceholder: "你的猜测",
            submitGuessButtonLabel: "提交猜测",
            history: {
                buttonLabel: "历史记录",
            },
            stats: {
                buttonLabel: "统计数据",
                correctGuesses: "答对次数：{{count}} / {{total}}（{{percent}}%）",
                averageTime: "平均用时：{{time}} 秒",
                reset: "重置统计数据",
                confirmation: "你确定要重置统计数据吗？",
                yes: "是",
                no: "否",
            },
        },
        utils: {
            convertHeader: "手牌转换",
            convertButtonLabel: "转换手牌",
            ascii: "ASCII:",
            emoji: "Emoji:",
            stateHeader: "随机游戏状态生成器",
            playerLabel: "{{seat}}家 玩家 {{you}}",
            points: "点数：",
            discards: "舍牌",
            stateButtonLabel: "生成新的状态",
            info: "第{{turn}}轮 第{{round}}. 你是{{seat}}家 玩家.",
            dora: "宝牌指示牌是{{tile}}."
        }
    }
}
